var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.$t('routerBase.'+_vm.$route.meta.i18n),"left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})}
var staticRenderFns = []

export { render, staticRenderFns }